// Factura
import DocumentoPage from "./DocumentoPage.js";

const Factura = () => (
  <DocumentoPage
      title="Ingreso de Cotización Factura"
      tipoDocumento="factura"
      initialLoading={false}
      showFilter={true}
  />
);

export default Factura;